'use client';

import classNames from 'classnames';
import { ReactNode } from 'react';
import logSponsoredListExternalClicked from '@alltrails/amplitude/events/logSponsoredListExternalClicked';
import Button from '@alltrails/denali/components/Button';
import styles from './styles/styles.module.scss';

// Designs: https://www.figma.com/design/Y27OVUVzKrRbVqPXo5MVmG/Newsroom-Phase-II?node-id=680-20737&m=dev

type Props = {
  buttonLocation: number;
  buttonText: string;
  link: string;
  children: ReactNode;
  postTitle: string;
};

export default function CallToAction({ buttonLocation, buttonText, link, children, postTitle }: Props) {
  return (
    <div className={classNames(styles.cta, 'at-block--cta')}>
      <div className={styles.ctaContent}>{children}</div>
      <Button
        linkInfo={{ href: link, target: '_blank' }}
        onClick={() => {
          logSponsoredListExternalClicked({
            button_location: buttonLocation,
            button_text: buttonText,
            external_link_url: link,
            page_title: postTitle
          });
        }}
        size="md"
        text={buttonText}
        variant="primary"
      />
    </div>
  );
}
